import clsx from 'clsx'

import { Icon } from '@fv/client-components'
import { fvDate } from '@fv/dates'
import type { LoadNote } from '@fv/models'
import type { DTO } from '@fv/models/core'

import { List, ListItem } from '@/components/List'

type AuditNotesProps = {
  className?: string
  notes?: DTO<Array<LoadNote>>
}

const AuditNotes = ({ className = '', notes }: AuditNotesProps) => {
  if (!notes) return null

  const sortedNotes = notes.sort(
    (a, b) =>
      new Date(b.createdDate).valueOf() - new Date(a.createdDate).valueOf(),
  )

  return (
    <List className={className}>
      {sortedNotes.map(n => {
        const timestamp = fvDate(n.createdDate).format('ddd MMM D h:mma')

        return (
          <ListItem key={n._id} className="!gap-x-0">
            <Icon
              icon={n.source === 'shipper' ? 'sticky-note' : 'paper-plane'}
              className={clsx({
                'text-fv-gray-dark': n.source === 'shipper',
                'text-fv-orange': n.source === 'system',
              })}
              transform="up-1"
            />

            <p className="mb-0">
              {timestamp} - {n.message}
            </p>
          </ListItem>
        )
      })}
    </List>
  )
}

export default AuditNotes
